define('RTC.Model', [
    'Backbone',
    'underscore',
    'Utils'
], function RTCModel(
    Backbone,
    _
) {
    'use strict';

    return Backbone.Model.extend({
        urlRoot: _.getAbsoluteUrl('services/RTC.Service.ss')
    });
});

